import { DataHeader, DataSource, Label, Layout, Panel, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutTariffRegionAdvanceSearch extends Layout {
    dataHeaderTariffRegion: DataHeader;
    labeTariffRegionZipCode: Label;
    labelTariffRegionDetails: Label;
    labelTariffRegionLocation: Label;
    panelTariffRegionDetails: Panel;
    panelTariffRegionLocation: Panel;
    panelTariffRegionZipCode: Panel;
    sourceTariffRegionBrokerageZipLocation: DataSource;
    sourceTariffRegionLoc: DataSource;
    sourceTariffRegionZip: DataSource;
    textboxEffectiveDate: Textbox;
    textboxEffectiveTimestamp: Textbox;
    textboxExpirationDate: Textbox;
    textboxExpireTimestamp: Textbox;
    textboxFdZipcode: Textbox;
    textboxLocationId: Textbox;
    textboxRegionName: Textbox;
    textboxRegionNickname: Textbox;
    textboxStateId: Textbox;
}
